import { Directive, Input, inject } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, UntypedFormGroup, ValidationErrors, Validator } from '@angular/forms';
import { errorMessages } from '../../../models';
import { AffordabilityService } from '../../../services';
import { FormsValidators } from '../validators/forms.validators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[maxLtvValidator]',
  // eslint-disable-next-line no-use-before-define
  providers: [{ provide: NG_VALIDATORS, useExisting: MaxLtvValidatorDirective, multi: true }],
})
export class MaxLtvValidatorDirective implements Validator {
  private readonly affordabilityService = inject(AffordabilityService);

  @Input() public lendingType: 'btl' | 'resi';

  public validate(formGroup: UntypedFormGroup): ValidationErrors {
    return this.lendingType ? this.validateLoanAmount(formGroup) : this.validateBtlType();
  }

  private validateLoanAmount(formGroup: UntypedFormGroup): ValidationErrors {
    const loanAmountControl = formGroup.controls['loanAmount'];

    if (!loanAmountControl || (loanAmountControl.errors && !loanAmountControl.errors.ltv95Percent)) {
      return null;
    }

    const error = FormsValidators.loanAmountValidator(this.affordabilityService.model.propertyAndLoan);
    const errors = !error ? null : { [error]: true };

    loanAmountControl.setErrors(errors);
    return errors;
  }

  private validateBtlType(): ValidationErrors {
    const btlTypeControl: AbstractControl = this.affordabilityService.form?.get('propertyAndLoan')?.get('btlType');
    if (!btlTypeControl) {
      return null;
    }

    const error: keyof typeof errorMessages =
      FormsValidators.ltvValidatorBTLType(btlTypeControl.value, this.affordabilityService.model);
    const errors = !error ? null : { [error]: true };

    btlTypeControl.setErrors(errors);

    return errors;
  }
}
